import { defineFcm } from '../shared/factory';

export const FCM_ADMIN_USER_SEARCH_TYPESENSE = defineFcm('admin_user_search_typesense')
	.asBoolean()
	.withDefault(false)
	.toConfig({
		owner: 'squad-site-platform',
		scope: 'corgi-middle-end',
		context: 'Admin user search',
		description: 'Use Typesense for admin user search instead of the search service',
		import: false,
		deprecated: 'Reverted — user search returns to search service. Safe to delete after 2026-07-15.',
	});
